// Turns Instagram links in an article into embedded posts. An editor pastes the
// post's URL on its own line, or Instagram's full embed code (Shopify's editor
// drops the script tag from that code, so the theme frames the post itself).
(function () {
  var POST_URL = /^https?:\/\/(?:www\.)?instagram\.com\/(?:[\w.]+\/)?(p|reels?|tv)\/([\w-]+)/i;
  var FALLBACK_DELAY = 6000;

  function buildEmbed(match) {
    var type = match[1].toLowerCase().replace('reels', 'reel');
    var frame = document.createElement('iframe');
    frame.className = 'si-instagram-embed';
    frame.src = 'https://www.instagram.com/' + type + '/' + match[2] + '/embed/';
    frame.title = 'Instagram post';
    frame.loading = 'lazy';
    frame.allowFullscreen = true;
    frame.setAttribute('scrolling', 'no');

    // Instagram refuses some public posts, showing "this link may be broken" in
    // the frame. Those never report a height, so swap in a plain link instead.
    frame.addEventListener('load', function () {
      setTimeout(function () {
        if (frame.dataset.measured || !frame.isConnected) return;
        var fallback = document.createElement('p');
        fallback.className = 'si-instagram-fallback';
        var link = document.createElement('a');
        link.href = 'https://www.instagram.com/' + type + '/' + match[2] + '/';
        link.target = '_blank';
        link.rel = 'noopener';
        link.textContent = 'View this post on Instagram';
        fallback.appendChild(link);
        frame.replaceWith(fallback);
      }, FALLBACK_DELAY);
    });
    return frame;
  }

  // Instagram's frame reports its content height; fit to it.
  window.addEventListener('message', function (event) {
    if (!/instagram\.com$/.test(event.origin)) return;
    var data;
    try {
      data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
    } catch (e) {
      return;
    }
    if (!data || data.type !== 'MEASURE' || !data.details || !data.details.height) return;
    document.querySelectorAll('iframe.si-instagram-embed').forEach(function (frame) {
      if (frame.contentWindow !== event.source) return;
      frame.dataset.measured = 'true';
      frame.style.height = data.details.height + 'px';
    });
  });

  function init() {
    document.querySelectorAll('.article-template__content').forEach(function (content) {
      content.querySelectorAll('blockquote.instagram-media').forEach(function (quote) {
        var link = quote.getAttribute('data-instgrm-permalink') || (quote.querySelector('a') || {}).href || '';
        var match = link.match(POST_URL);
        if (match) quote.replaceWith(buildEmbed(match));
      });
      content.querySelectorAll('p, div').forEach(function (block) {
        if (block.children.length > 1 || block.querySelector('img, iframe, blockquote')) return;
        var text = block.textContent.trim();
        var match = text.match(POST_URL);
        if (match && !/\s/.test(text)) block.replaceWith(buildEmbed(match));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
